const EmptyDockDoor = ({ dockDoor }) => {
  return (
    <div className="dock-door empty-dock-door">
      <h1> DOOR {dockDoor}</h1>
    </div>
  );
};

export default EmptyDockDoor;
